module.exports = __webpack_public_path__ + "static/media/elite_badge.c78b8037.svg";